import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

import { handleMfaRequired } from '@/features/auth/mfa/guard';
import { ApiError } from '@/shared/api/client';

export function createQueryClient(): QueryClient {
  /*
   * MFA contract: any request refused with MFA_CHALLENGE_REQUIRED or
   * MFA_ENROLMENT_REQUIRED returns its session to the MFA step, whichever
   * screen made it. One place, so no screen has to remember.
   */
  const onError = (error: unknown) => {
    handleMfaRequired(queryClient, error);
  };

  const queryClient: QueryClient = new QueryClient({
    queryCache: new QueryCache({ onError }),
    mutationCache: new MutationCache({ onError }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          // Authorization and validation outcomes are answers, not transient
          // failures; retrying them only delays the message to the user.
          if (error instanceof ApiError && error.status < 500) return false;

          return failureCount < 2;
        },
      },
      mutations: { retry: false },
    },
  });

  return queryClient;
}
